import React, { useState } from 'react';
import './Editor.scss'
import { CodeSpaceProps } from '../../types/codeBaseType'
import CodeEditor from '@uiw/react-textarea-code-editor';
import { Icons } from '../../assets/icons/icon';
import Tooltip from '@mui/material/Tooltip'; // Add this import

const Editor: React.FC<CodeSpaceProps> = ({ content }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        await navigator.clipboard.writeText(content['content'] || '');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="code-content">
            <div className="fileName-wrapper">
                {content?.["fileName"]}
                {
                    content["content"] && (
                        <span className="copy-icon-wrapper" style={{ position: 'relative', display: 'inline-block', alignItems: "center" }}>
                            <Tooltip
                                title="Copied"
                                open={copied}
                                placement="left"
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                            >
                                <button className='not-a-button' onClick={handleCopy}>
                                    <img
                                        src={Icons.Copy}
                                        alt='copy'
                                    />
                                </button>
                            </Tooltip>
                        </span>
                    )
                }
            </div>
            <div className="code">
                <CodeEditor
                    value={content['content']}
                    language={content['fileName']?.split('.')?.pop()?.toLowerCase()}
                    placeholder=""
                    className='editor'
                    // onChange={(evn) => setCode(evn.target.value)}
                    padding={15}
                    style={{
                        backgroundColor: "white",
                        pointerEvents: "none",
                        fontFamily: 'var(--Inter)',
                        lineHeight: "24px",
                        color: "#2C2C2C",
                        fontSize: "13px",
                        letterSpacing: "0.15px"
                    }}
                />
            </div>
        </div>
    )
}

export default Editor;